import { useCallback } from 'react';

import { Source } from '@/scenarios/legacy-player/types/config';

import { PlayerBaseInfoContent } from '../../../player-manager/context/PlayerBaseInfoProvider';

export type StreamHandler = (baseInfo: PlayerBaseInfoContent) => null | Source[];

export const useStreamHandler: (
    handlers: Array<StreamHandler>
) => (baseInfo: PlayerBaseInfoContent) => Source[] = (handlers) =>
    useCallback(
        (baseInfo) =>
            handlers.reduce<Source[]>((acc, handler) => {
                const transformedSources = handler(baseInfo);
                if (transformedSources !== null) {
                    acc.push(...transformedSources);
                }
                return acc;
            }, []),
        [handlers]
    );
